export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "报建编号：",
            type: "input",
            value: "constructionNo",
            disabled: true,
          },
          {
            label: "项目名称：",
            type: "input",
            value: "prjName",
            disabled: true,
          },
          {
            label: "备案项目类别：",
            type: "input",
            value: "tenderClassNumName",
            disabled: true,
          },
          {
            label: "备案项目内容：",
            type: "input",
            value: "tenderContent",
            disabled: true,
          },
        ]
      },
      {
        title: "施工单位信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "施工单位名称：",
            type: "input",
            value: "corpName",
            disabled: true,
          },
          {
            label: "项目负责人（总监）：",
            type: "input",
            value: "personName",
            disabled: true,
          },
          {
            label: "工程造价（万元）：",
            type: "input",
            value: "winningPrice",
            disabled: true,
          },
        ]
      },
      {
        title: "证照及证明文件扫描件",
        name: "3",
        icon: "",
        tipsList: [
          { text: "上传文件要求" },
          { text: "1、《项目负责人（项目总监）任职解除锁定申请表》及经办人身份证明材料。其中经办人身份证明材料应包括：申请单位法定代表人证明书、法定代表人授权委托证明书原件和被授权人身份证明；" },
          { text: "2、解锁理由的证明材料：" },
          { text: " （1）工程已实际完工并竣工验收合格，但暂时无法办理竣工验收备案手续的，提交经建设单位签章认可及建设行政主管部门盖章的书面申请书原件和竣工验收报告；" },
          { text: " （2）非监理方原因致使工程停工达到120天的，提交经建设单位签章认可的书面申请书原件和停工登记证明文件；" },
          { text: " （3）因拆迁、资金等原因，造成工程未按期开工超过六个月的，提交建设单位出具的未开工证明文件原件；" },
          { text: " （4）在建工程的总监理工程师（项目总监）已变更的，提交变更证明文件。" },
        ],
        formConfigList: [
          {
            label: "证照及证明文件扫描件：",
            type: "slot",
            slotName: "uploadFile",
          },
        ]
      },
      {
        title: "状态",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "状态：",
            type: "input",
            value: "stateName",
            disabled: true,
          },
          {
            label: "历史审核记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
    ];
  }
}
